import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/es/storage';
import {
  userReducer,
  wizardReducer,
  globalStylesReducer,
  selectedBuReducer,
  availableBusReducer,
  busMapReducer,
  stringsReducer,
  stringsLoadedReducer,
  isAuthenticatedReducer,
  isUnderMaintenanceReducer,
  isUnderMaintenanceMessageReducer,
  busStylesMapReducer,
  busFuncMapReducer,
  busFuncMapDefaultReducer,
  digitalCommunicationsReducer,
  loadingInfoReducer,
  purposesReducer,
  ibanReducer,
  titularReducer,
  bankAccountDataHolderReducer,
  stringsDefaultReducer,
  productsReducer,
  customerCardModalTriggerReducer,
  ibanFilterOpenTriggerReducer,
  busFunctionalitiesReducer,
  busStylesReducer,
  busProductExceptionsReducer,
  busGroupExceptionsReducer,
  buDefaultFunctionalitiesReducer,
  patientsReducer,
  selectedBuReadyReducer,
  consultasOnlineEnabledReducer,
  isLanguageSelectedReducer,
  languageReducer,
  languageOptionsReducer,
  currenciesReducer,
  accessTokenReducer,
  tenantReducer,
  medicoOnlineEnabledReducer,
  showPersonalDateReducer,
  updateRoutesNewSelectedPatientReducer,
  disableReimbursementRequestButtonReducer,
  userBankAccountDataWasUpdatedReducer,
  busFuncMapDefaultObjectReducer,
} from './mix';

const config = (key: any) => ({key, storage});

const AppReducer = combineReducers({
  isAuthenticated: persistReducer(
    config('isAuthenticated'),
    isAuthenticatedReducer
  ),
  isUnderMaintenance: persistReducer(
    config('isUnderMaintenance'),
    isUnderMaintenanceReducer
  ),
  isUnderMaintenanceMessage: persistReducer(
    config('isUnderMaintenanceMessage'),
    isUnderMaintenanceMessageReducer
  ),
  loadingInfo: persistReducer(config('loadingInfo'), loadingInfoReducer),
  digitalCommunications: persistReducer(
    config('digitalCommunications'),
    digitalCommunicationsReducer
  ),
  user: persistReducer(config('user'), userReducer),
  wizard: persistReducer(config('wizard'), wizardReducer),
  globalStyles: persistReducer(config('globalStyles'), globalStylesReducer),
  selectedBu: persistReducer(config('selectedBu'), selectedBuReducer),
  availableBus: persistReducer(config('availableBus'), availableBusReducer),
  busMap: persistReducer(config('busMap'), busMapReducer),
  busStylesMap: persistReducer(config('busStylesMap'), busStylesMapReducer),
  busFuncMap: persistReducer(config('busFuncMap'), busFuncMapReducer),
  busFuncMapDefault: persistReducer(
    config('busFuncMapDefault'),
    busFuncMapDefaultReducer
  ),
  strings: persistReducer(config('strings'), stringsReducer),
  stringsLoaded: persistReducer(config('stringsLoaded'), stringsLoadedReducer),
  stringsDefault: persistReducer(
    config('stringsDefault'),
    stringsDefaultReducer
  ),
  purposes: persistReducer(config('setPurposes'), purposesReducer),
  iban: persistReducer(config('iban'), ibanReducer),
  titular: persistReducer(config('titular'), titularReducer),
  bankAccountDataHolder: persistReducer(
    config('bankAccountDataHolder'),
    bankAccountDataHolderReducer
  ),
  updateRoutesNewSelectedPatient: persistReducer(
    config('updateRoutesNewSelectedPatient'),
    updateRoutesNewSelectedPatientReducer
  ),
  produtos: persistReducer(config('produtos'), productsReducer),
  showCardModal: persistReducer(
    config('showCardModal'),
    customerCardModalTriggerReducer
  ),
  ibanFilter: persistReducer(
    config('ibanFilter'),
    ibanFilterOpenTriggerReducer
  ),
  busFunctionalities: persistReducer(
    config('busFunctionalities'),
    busFunctionalitiesReducer
  ),
  busStyles: persistReducer(config('busStyles'), busStylesReducer),
  busProductExceptions: persistReducer(
    config('busProductExceptions'),
    busProductExceptionsReducer
  ),
  busGroupExceptions: persistReducer(
    config('busGroupExceptions'),
    busGroupExceptionsReducer
  ),
  buDefaultFunctionalities: persistReducer(
    config('buDefaultFunctionalities'),
    buDefaultFunctionalitiesReducer
  ),
  patients: persistReducer(config('patients'), patientsReducer),
  selectedBuReady: persistReducer(
    config('selectedBuReady'),
    selectedBuReadyReducer
  ),
  consultasOnlineEnabled: persistReducer(
    config('consultasOnlineEnabled'),
    consultasOnlineEnabledReducer
  ),
  medicoOnlineEnabled: persistReducer(
    config('medicoOnlineEnabled'),
    medicoOnlineEnabledReducer
  ),
  isLanguageSelected: persistReducer(
    config('isLanguageSelected'),
    isLanguageSelectedReducer
  ),
  language: persistReducer(config('language'), languageReducer),
  languageOptions: persistReducer(
    config('languageOptions'),
    languageOptionsReducer
  ),
  currencies: persistReducer(config('currencies'), currenciesReducer),
  accessToken: persistReducer(config('accessToken'), accessTokenReducer),
  tenant: persistReducer(config('tenant'), tenantReducer),
  showPersonalDate: persistReducer(
    config('showPersonalDate'),
    showPersonalDateReducer
  ),
  disableReimbursementRequestButton: persistReducer(
    config('disableReimbursementRequestButton'),
    disableReimbursementRequestButtonReducer
  ),
  userBankAccountDataWasUpdated: persistReducer(
    config('userBankAccountDataWasUpdated'),
    userBankAccountDataWasUpdatedReducer
  ),
  busFuncMapDefaultObject: persistReducer(
    config('busFuncMapDefaultObject'),
    busFuncMapDefaultObjectReducer
  ),
});

export default AppReducer;
